import { createSelector } from "@reduxjs/toolkit";
// announcement banner
const getAnnouncementState = (state: any) => state.orgPolicyAnnouncementMaster;

const getAnnouncementDivisions = createSelector(
    [getAnnouncementState],
    data => {
        return data?.divisions
    }
);
const getAnnouncementRoles = createSelector(
    [getAnnouncementState],
    data => {
        return data?.roles
    }
);
const getMessageOccurence = createSelector(
    [getAnnouncementState],
    data => {
        return data?.announcmentreOccurenceFrequency
    }
);
const getSelectedTab = createSelector(
    [getAnnouncementState],
    data => {
        return data?.selectedTab
    }
);
const getAddAnnouncementResponse = createSelector(
    [getAnnouncementState],
    data => {
        return data?.addAnnouncementResponse
    }
);
const getAllAnnouncements = createSelector(
    [getAnnouncementState],
    data => {
        return data?.allAnnouncements
    }
);
const getShownAnnouncements = createSelector(
    [getAnnouncementState],
    data => {
        return data?.shownAnnouncements
    }
);
const getHistoricalAnnouncementsList = createSelector(
    [getAnnouncementState],
    data => {
        return data?.historicalAnnouncementsList
    }
);
const getSingleAnnouncementDetail = createSelector(
    [getAnnouncementState],
    data => {
        return data?.singleAnnouncementDetail
    }
);
const getAbortAnnouncementResponse = createSelector(
    [getAnnouncementState],
    data => {
        return data?.abortAnnouncementResponse
    }
);
const getIsRelaunchInitiated = createSelector(
    [getAnnouncementState],
    data => {
        return data?.isRelaunchInitiated
    }
);
const getSelectedRadioActions = createSelector(
    [getAnnouncementState],
    data => {
        return data?.selectedRadioActions
    }
);


export const announcementSelector = {
    getAnnouncementDivisions: ()=>getAnnouncementDivisions, 
    getAnnouncementRoles: ()=>getAnnouncementRoles, 
    getMessageOccurence: ()=>getMessageOccurence,
    getSelectedTab: ()=>getSelectedTab ,
    getAddAnnouncementResponse: ()=>getAddAnnouncementResponse,
    getAllAnnouncements: ()=>getAllAnnouncements,
    getShownAnnouncements: ()=>getShownAnnouncements,
    getHistoricalAnnouncementsList: ()=>getHistoricalAnnouncementsList,
    getSingleAnnouncementDetail: ()=>getSingleAnnouncementDetail,
    getAbortAnnouncementResponse: ()=>getAbortAnnouncementResponse,
    getIsRelaunchInitiated: ()=>getIsRelaunchInitiated,
    getSelectedRadioActions: ()=>getSelectedRadioActions,
}
